module.exports = __webpack_public_path__ + "static/Java2018Cert-79f43080f18b0d6b50d1d5bc24e09dea.png";